
import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

import 'swiper/css/bundle';

@Component({
  name: 'catalog-product-list-item-swatches',
  components: {
    ...ServiceContainer().getComponents(),
    Swiper,
    Navigation,
  },
})

export default class extends Vue {
  @Prop({required: true}) readonly swatches: object;
  @Prop({required: true}) readonly productId: number;

  private swiper: Swiper | null = null;

  private created(): void {
    this.$nextTick(() => {
      this.swiper = new Swiper(`.swiper-${this.productId} .swiper`, {
        modules: [Navigation],
        slidesPerView: 2,
        roundLengths: true,
        navigation: {
          nextEl: `.swiper-${this.productId} .swiper__button.--next`,
          prevEl: `.swiper-${this.productId} .swiper__button.--prev`,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
        },
      });
    });
  }

  private imageSrc(imageUrl: string): string {
    if ( ! imageUrl) {
      return this.$parent['defaultPlaceholder'];
    }

    return `${this.$solarCdnBaseUrl}/cdn/resize-extended/rs:fill/w:70/h:70/extend:true/background:255:255:255/bl:10.0/q:40/path/media/catalog/product${imageUrl}`;
  }

  private imageDataSrc(imageUrl: string): string {
    if ( ! imageUrl) {
      return this.$parent['defaultPlaceholder'];
    }

    return `${this.$solarCdnBaseUrl}/cdn/resize-extended/rs:fill/w:70/h:70/extend:true/background:255:255:255/path/media/catalog/product${imageUrl} 1x,
    ${this.$solarCdnBaseUrl}/cdn/resize-extended/rs:fill/w:140/h:140/extend:true/background:255:255:255/path/media/catalog/product${imageUrl} 2x`;
  }

  private changeParentImage(value): void {
    this.$eventBus.$emit('change-image', value, this.productId);
  }
}
